import React from 'react';
import { Dialog, Box, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PriorityHighRoundedIcon from '@mui/icons-material/PriorityHighRounded';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import * as styles from './styles';

function ConfirmDialog({
    open,
    variant = 'warn',
    title,
    subMessage,
    note,
    NoteIcon = AccessTimeIcon,
    confirmLabel = 'Yes',
    cancelLabel = 'Cancel',
    loading = false,
    onConfirm,
    onClose,
}) {
    const isSuccess = variant === 'success';

    function renderDismissButton() {
        // Nothing to dismiss to — the request this button kicked off is
        // already in flight.
        if (loading) return null;
        return (
            <Box component="button" onClick={onClose} aria-label="Close" sx={styles.dismissButton}>
                <CloseIcon sx={{ fontSize: 16 }} />
            </Box>
        );
    }

    function renderIcon() {
        return (
            <Box sx={styles.iconWrapper(isSuccess)}>
                {isSuccess
                    ? <CheckRoundedIcon sx={styles.iconStyle(isSuccess)} />
                    : <PriorityHighRoundedIcon sx={styles.iconStyle(isSuccess)} />
                }
            </Box>
        );
    }

    function renderTitle() {
        return <Typography sx={styles.title}>{title}</Typography>;
    }

    function renderSubMessage() {
        return <Typography sx={styles.subMessage}>{subMessage}</Typography>;
    }

    function renderNote() {
        if (!note) return null;
        return (
            <Box sx={styles.noteRow}>
                <NoteIcon sx={styles.noteIcon} />
                <Typography sx={styles.noteText}>{note}</Typography>
            </Box>
        );
    }

    function renderActions() {
        if (isSuccess) {
            return (
                <Box component="button" onClick={onClose} disabled={loading} sx={styles.confirmButton}>
                    {cancelLabel === 'Cancel' ? 'Close' : cancelLabel}
                </Box>
            );
        }
        return (
            <Box sx={styles.actionsRow}>
                <Box component="button" onClick={onConfirm} disabled={loading} sx={styles.confirmButton}>
                    {confirmLabel}
                </Box>
                <Box component="button" onClick={onClose} disabled={loading} sx={styles.cancelButton}>
                    {cancelLabel}
                </Box>
            </Box>
        );
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={false}
            sx={styles.dialog}
            slotProps={{ backdrop: { sx: styles.backdrop } }}
        >
            {renderDismissButton()}
            {renderIcon()}
            {renderTitle()}
            {renderSubMessage()}
            {renderActions()}
            {renderNote()}
        </Dialog>
    );
}

export default ConfirmDialog;
